import { useMutation, useQueryClient } from 'react-query';
import { deleteRecognitionAsync } from 'services/Recognition';
import { RECOGNITION_KEYS } from 'services/Recognition/hooks/useQuery';
import { IRecognitionTypes } from '../../../types';
import {
  createResponsibleRecognitionAsync,
  createResponsibleRecognitionAsyncJob,
  deleteResponsibleRecognitionAsyncJob,
  getAllResponsibleByLicenseAsync,
  getAllResponsiblesForSelectionAsync,
  getResponsibleRecognitionByIdAsync,
  updateResponsibleRecognitionAsync,
  updateResponsibleRecognitionAsyncJob,
} from '../../index';
import { RESPONSIBLE_KEYS } from '../useQuery';
import { SCHOOL_CLASS_KEYS } from 'services/SchoolClass/hooks/useQuery';

export const useCreateResponsibleRecognitionAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(createResponsibleRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
    }
  });
};

export const useCreateResponsibleRecognitionAsyncJob = () => {
  const queryClient = useQueryClient();

  return useMutation(createResponsibleRecognitionAsyncJob, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
    }
  });
};

export const useUpdateResponsibleRecognitionAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(updateResponsibleRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
      queryClient.invalidateQueries([SCHOOL_CLASS_KEYS.ALL]);
    }
  });
};

export const useUpdateResponsibleRecognitionAsyncJob = () => {
  const queryClient = useQueryClient();

  return useMutation(updateResponsibleRecognitionAsyncJob, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
    }
  });
};

export const useDeleteResponsibleAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) => deleteRecognitionAsync({ id, type: IRecognitionTypes.RESPONSIBLE }), 
    {
      onSuccess: () => {
        queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
        queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]); 
      }
    }
  );
};

export const useDeleteResponsibleRecognitionAsyncJob = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteResponsibleRecognitionAsyncJob, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
      queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]);
    }
  });
};

export const useGetResponsibleRecognitionByIdAsync = () =>
  useMutation(getResponsibleRecognitionByIdAsync);

export const useGetAllResponsibleByLicenseMutateAsync = () =>
  useMutation(getAllResponsibleByLicenseAsync);

export const useGetAllResponsiblesForSelectionMutateAsync = () => {
  return useMutation(getAllResponsiblesForSelectionAsync);
};
